<template>
  <div class="flex flex-col items-center m-5 mt-24 text-white">
    <div v-html="mensaje" />
    <div>
      <button @click="inicio" class="bg-paleta-3 hover:bg-blue-700 text-white font-bold mt-5 py-2 px-4 rounded">Inicio</button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import textosService from "@/services/TextosService";

export default {
  data() {
    return {
      mensaje: ""
    };
  },
  mounted() {
    textosService.obtenerTextoApp("SOLICITUD_ACT_CARGADA", this.token, response => {
      if (response.data.resultado === "OK") {
        this.mensaje = response.data.texto;
      } else {
        this.mensaje = "Se ha producido un error";
      }
    });
  },
  methods: {
    inicio() {
      this.$router.push("/menu");
    }
  },
  computed: {
    ...mapState({
      token: state => state.sesion.usuario.token
    })
  }
};
</script>
